"use client";
import { BookOpen } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const AuthorCard = ({ author }) => {
  const [imgSrc, setImgSrc] = useState(author?.image || "/dummyauthor.jpg");

  return (
    <Link
      href={`/author/${author?.slug}`}
      title={author?.name}
      className="group flex h-full flex-col items-center rounded-2xl border border-brand-light bg-white p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-brand-sky/40 hover:shadow-brand-lg"
    >
      <div className="relative">
        <div className="relative h-28 w-28 overflow-hidden rounded-full ring-4 ring-brand-sky/25 transition-all duration-300 group-hover:ring-brand-sky">
          <Image
            src={imgSrc}
            alt={author?.name || "Author"}
            fill
            sizes="112px"
            className="object-cover transition-transform duration-500 group-hover:scale-110"
            onError={() => setImgSrc("/dummyauthor.png")}
          />
        </div>
        {author?.totalBooks != null && (
          <div className="absolute -bottom-1 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full gradient-primary px-2.5 py-1 text-[10px] font-bold text-white shadow-brand">
            <BookOpen size={10} />
            {author.totalBooks}
          </div>
        )}
      </div>

      <h3 className="mt-5 line-clamp-2 min-h-[2.5rem] text-sm font-bold leading-tight text-brand-navy transition-colors group-hover:text-brand-deep">
        {author?.name}
      </h3>
    </Link>
  );
};

export default AuthorCard;